import { createFeatureSelector, createSelector } from '@ngrx/store';
import { RuleResultState } from '../reducers/rule-result.reducer';

export const selectTrendState =
  createFeatureSelector<RuleResultState>('RuleResult');

export const selectTrendEntry = (uid: string, range: string) =>
  createSelector(
    selectTrendState,
    (state) => state.entities[`${uid}::${range}`],
  );

export const selectTrendData = (uid: string, range: string) =>
  createSelector(selectTrendEntry(uid, range), (e) => e?.rawData ?? null);

export const selectTrendLoading = (uid: string, range: string) =>
  createSelector(selectTrendEntry(uid, range), (e) => !!e?.loading);

export const selectHealthIndicatorTrendEntry = (uid: string, range: string) =>
  createSelector(
    selectTrendState,
    (state) => state.entitiesHealthIndicator[`${uid}::${range}`],
  );

export const selectHealthIndicatorTrendData = (uid: string, range: string) =>
  createSelector(
    selectHealthIndicatorTrendEntry(uid, range),
    (e) => e?.rawData ?? null,
  );

export const selectHealthIndicatorTrendLoading = (uid: string, range: string) =>
  createSelector(
    selectHealthIndicatorTrendEntry(uid, range),
    (e) => !!e?.loading,
  );

export const selectAlarmDetailsTrendEntry = (uid: string, range: string) =>
  createSelector(
    selectTrendState,
    (state) => state.entitiesAlarmDetails[`${uid}::${range}`],
  );

export const selectAlarmDetailsTrendData = (uid: string, range: string) =>
  createSelector(
    selectAlarmDetailsTrendEntry(uid, range),
    (e) => e?.rawData ?? null,
  );

export const selectAlarmDetailsTrendLoading = (uid: string, range: string) =>
  createSelector(selectAlarmDetailsTrendEntry(uid, range), (e) => !!e?.loading);
